import { Component, Input, OnInit } from '@angular/core';
import { LeadService } from '../../../../core/services/lead.service';
import { ActionLogService } from '../../../../core/services/action-log.service';
import * as _ from 'lodash';

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-action-log',
  templateUrl: './action-log.component.html',
  styleUrls: ['./action-log.component.scss'],
})
export class ActionLogComponent implements OnInit {
  @Input() documentId: any | undefined;
  @Input() documentType: any | undefined;
  //Lead history data
  actionLogHistory: any[] = [];
  totalRecords = 0;
  first: number = 0;
  rows: number = 10;
  page: number = 1;
  loadingActionLogTable = false;
  readonly skeletonRows = [1, 2, 3];
  messageDialogOpen = false;
  messageDialogText = '';
  messageIsJson = false;
  private readonly messagePreviewLimit = 160;

  constructor(private actionLogService: ActionLogService) {}

  ngOnInit() {
    this.actionLogService.actionLogDataOnChange.subscribe((logData: any) => {
      this.actionLogHistory = logData?.[0]?.data || [];
      this.totalRecords = logData?.[0]?.metadata?.[0]?.total || 0;
    });
    this.onActionLogTable();
  }

  // Lead history related functions start
  onPageChange(event: PageEvent) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1;
    this.onActionLogTable();
  }

  onActionLogTable() {
    this.loadingActionLogTable = true;
    try {
      this.actionLogService
        .getAllLogsById({
          filter: this.documentId,
          pageIndex: this.page,
          pageSize: this.rows,
        })
        .then(res => {
          // this.actionLogService.actionLogDataOnChange.subscribe(
          //   (logData: any) => {
          this.loadingActionLogTable = false;
          //     this.actionLogHistory = logData[0]?.data;
          //     this.totalRecords = logData[0]?.metadata[0]?.total;
          //   }
          // );
        });
    } catch (e) {
      this.loadingActionLogTable = false;
    }
  }

  getActionDescription(action: any): string {
    let descriptionText = '';
    switch (action.event) {
      case 'CREATE':
        switch (action.relatedModelAndCollection) {
          case 'Lead:leads':
            descriptionText = 'Lead created.';
            break;
          case 'Invoice:invoices':
            descriptionText = 'Invoice created.';
            break;
          case 'Quotation:quotations':
            descriptionText = 'Quotation created.';
            break;
          case 'Job:jobs':
            descriptionText = 'Job created.';
            break;
          case 'RecurringJob:recurringjobs':
            descriptionText = 'Recurring Job created.';
            break;
          case 'AdditionalJob:additionaljobs':
            const message: string =
              action.originalDocument.jobType === 'CONTRACT_WORK'
                ? 'Contract Work Created.'
                : 'Additional Work Created.';
            descriptionText = message;
            break;
          case 'Inventory:inventories':
            descriptionText = 'Inventory item created.';
            break;
          case 'Client:clients':
            descriptionText = 'Client created.';
            break;
        }
        return descriptionText;
      case 'UPDATE':
        const properties: string[] = [];
        switch (action.relatedModelAndCollection) {
          case 'Client:clients':
            if (action.changes?.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else if (action.changes?.property) {
              descriptionText = `${action.changes.property} data updated.`;
            } else {
              descriptionText = 'Client updated.';
            }
            break;
          case 'Lead:leads':
            if (action.changes.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else {
              descriptionText = `${action.changes.property} data updated.`;
            }
            break;
          case 'Invoice:invoices':
            if (action.changes.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else {
              descriptionText = `${action.changes.property} data updated.`;
            }
            break;
          case 'Quotation:quotations':
            if (action.changes.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else {
              descriptionText = `${action.changes.property} data updated.`;
            }
            break;
          case 'Job:jobs':
            if (action.changes.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else {
              descriptionText = `${action.changes.property} data updated.`;
            }
            break;
          case 'RecurringJob:recurringjobs':
            if (action.changes.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else {
              descriptionText = `${action.changes.property} data updated.`;
            }
            break;
          case 'AdditionalJob:additionaljobs':
            if (action.changes.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else {
              descriptionText = `${action.changes.property} data updated.`;
            }
            break;
          case 'Inventory:inventories':
            if (action.changes.length > 0) {
              action.changes.forEach((change: any) => {
                properties.push(_.startCase(change.property));
              });
              descriptionText = `${properties.join(', ')} data updated.`;
            } else {
              descriptionText = 'Inventory item updated.';
            }
            break;
        }
        return descriptionText;
      case 'DELETE':
        if (action.relatedModelAndCollection === 'Client:clients') {
          return 'Client deleted.';
        }
        return 'Record deleted.';
      default:
        return '';
    }
  }

  messagePreview(log: any): { preview: string; expandable: boolean; full: string } | null {
    const full = this.getActionDescription(log) || '';
    if (!full) return null;
    const expandable =
      full.length > this.messagePreviewLimit || this.looksLikeJson(full);
    const preview = expandable
      ? full.slice(0, this.messagePreviewLimit).trimEnd() + '…'
      : full;
    return { preview, expandable, full };
  }

  openMessage(log: any): void {
    const full = this.getActionDescription(log) || '';
    this.messageIsJson = this.looksLikeJson(full);
    if (this.messageIsJson) {
      try {
        this.messageDialogText = JSON.stringify(JSON.parse(full), null, 2);
      } catch {
        this.messageDialogText = full;
        this.messageIsJson = false;
      }
    } else {
      this.messageDialogText = full;
    }
    this.messageDialogOpen = true;
  }

  private looksLikeJson(text: string): boolean {
    const t = String(text || '').trim();
    return (
      (t.startsWith('{') && t.endsWith('}')) ||
      (t.startsWith('[') && t.endsWith(']'))
    );
  }
}
